module.exports = __webpack_public_path__ + "img/logo_oncogitiel_light.51e29d6f.png";